const JsFontSize = {
  init () {

    /*              __
                   / _)
            .-^^^-/ /
        __/       /
        <__.|_|-|_|

        The Emagine Dinosaur says; "We need to cater for everyone, some people want big fonts, some want small fonts, give them the choice.".
    */

    // Increase/decrease font size
    $('.decrease-font-size, .increase-font-size').click(function (e) {
      e.preventDefault();
      adjustFontSize($(this));
    });

    function reLayout() {


      setTimeout(function () {
        // $(document).foundation();

        window.dispatchEvent(new Event('resize'));
      }, 200);

      setTimeout(function () {

        // Relayout Isotope
        if ( $('.isotope-grid').length ) {
          $('.isotope-grid').isotope( 'layout' );
        }
      }, 300);
    }

    function adjustFontSize(clickedElement) {

      var fontSize = parseInt($('html').css('font-size').slice(0, -2));

      var clickedElementClass = clickedElement.attr("class");

      var minSize = 12;
      var maxSize = 20;

      if ((clickedElementClass == 'decrease-font-size') && (fontSize > 12)) {
        $('html').css('font-size', fontSize -= 2);

        let windowWidth = window.innerWidth;

        if (windowWidth < 768) {
          $('.e-site__title').css('font-size', '1.4rem');
        } else if ( windowWidth >= 768 ) {
          $('.e-site__title').css('font-size', '1.7rem');

          if (fontSize > 18 ) {
            $('.e-site__title').css('font-size', '1.5rem');
          }

        } else if ( windowWidth >= 850 ) {
          $('.e-site__title').css('font-size', '1.9rem');
        }

        reLayout();

      } else if ((clickedElementClass == 'increase-font-size') && (fontSize < 20)) {
        $('html').css('font-size', fontSize += 2);

        let windowWidth = window.innerWidth;

        // console.log(fontSize);

        if (windowWidth < 768) {
          $('.e-site__title').css('font-size', '1.4rem');
        } else if ( windowWidth >= 768 ) {
          $('.e-site__title').css('font-size', '1.7rem');

          if (fontSize > 18 ) {
            $('.e-site__title').css('font-size', '1.5rem');
          }
        } else if ( windowWidth >= 850 ) {
          $('.e-site__title').css('font-size', '1.9rem');
        }

        reLayout();
      }
    }


  }
};

export default JsFontSize;



// WEBPACK FOOTER //
// ./src/js/modules/font-size.js